<template lang="html">
  <v-layout :column="isMobile">

    <v-breadcrumbs class="pt-0"
                   v-if="onlyDetailsView">
      <slot name="breadcrumb">
        <v-breadcrumbs-item @click="$emit('reset')">
          Loads
        </v-breadcrumbs-item>

        <v-breadcrumbs-item v-if="_.get(selected, 'humanId', false)" disabled>
          {{selected.humanId}}
        </v-breadcrumbs-item>
      </slot>
    </v-breadcrumbs>

    <v-container fluid class="pa-0">
      <v-layout :row="!isMobile"
                :column="isMobile">
        <v-flex xs12 md3 v-if="!onlyDetailsView">
          <slot name="master"></slot>
        </v-flex>
        <v-flex :class="{'pl-2': !onlyDetailsView}"
                md9 v-if="onlyDetailsView || !isMobile">
          <slot name="detail"></slot>
        </v-flex>
      </v-layout>
    </v-container>

  </v-layout>
</template>

<script>
import _ from 'lodash';

export default {
  name: 'VMasterDetailPane',
  props: {
    selected: {
      type: Object,
      default: null,
    },
  },
  computed: {
    _() {
      return _;
    },
    isMobile() {
      return this.$vuetify.breakpoint.smAndDown;
    },
    onlyDetailsView() {
      return this.selected && this.isMobile;
    },
  },
};
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/MasterDetailPane.vue